module.exports = __webpack_public_path__ + "img/undraw_snap_the_moment_re_88cu.0a90bd76.svg";